import {BooleanInput, DateInput, NumberInput, SimpleForm,} from "react-admin";
import {FormProps} from "../../shared/types";
import {initInput} from "../../shared/utils";
import {Grid} from "@material-ui/core";
import {CustomToolbar} from "../../components/CustomToolbar";
import {ReferenceInputInvoice} from "../../components/reference-inputs/ReferenceInputInvoice";
import React from "react";

export const PaymentScheduleEditForm = (props: FormProps) => {

    return (
        <SimpleForm
            {...props}
            toolbar={
                <CustomToolbar canEdit={props.canEdit} canDelete={props.canDelete} />
            }
        >
            <Grid spacing={2} container alignItems="center" style={{ width: "100%" }}>
                <Grid item xs={4}>

                    <DateInput
                        {...initInput("expiration_date", props.fieldOptions, props.canEdit)}
                    />
                </Grid>

            </Grid>
        </SimpleForm>
    );
};
